import React, {lazy, Suspense, useEffect, useRef, useState} from "react";
import CategoryDialog from "../dialogs/CategoryDialog";
import LoaderComponent from "../loaders/LoaderComponent";
import LoadingAnimation from "../loaders/LoadingAnimation";
import {Box, CircularProgress} from '@mui/material';
import RequestSvc from "../../services/RequestSvc";
import {API} from "../../utils/Constants";
import "./search.css";
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry";
import {fetchCategories} from "../../api/api";
import {NAME_HEADER_AUTH} from "../../utils/Constants";
import getStoredValue from "../../services/UseLocalStorage";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const CardAdLazyComponent = lazy(() => import("../cardViews/CardViewAd"));
// Componente Card memorizado
const MemoizedCardAd = React.memo((
    {item, index, launchCategoryDialog, gridShowAdDetail, numberDuplicates}) => (
    <Suspense fallback={<LoaderComponent/>}>
        <CardAdLazyComponent
            key={item.LibraryID}
            index={index}
            item={item}
            launchCategoryDialog={launchCategoryDialog}
            gridShowAdDetail={gridShowAdDetail}
            numberDuplicates={numberDuplicates}
        />
    </Suspense>
));

function AdResultGrid({
                          queryString,
                          setShowDetails,
                          showDetails,
                          setItemSelectedDetail,
                          setSidebarOpen,
                          setShowContainerNoMoreData,
                          numberDuplicates,
                          setNewRow
                      }) {
    const [categories, setCategories] = useState([]);
    /**
     * Contiene los datos de la grilla, indexados por el collectionID o por el LibraryID
     */
    //const [rowsIndex] = useState([]);
    /**
     * Contiene los datos de la grilla.
     */
    const [rowsAdsData, setRowsAdsData] = useState([]);
    /**
     * Indica si hay mas paginas o anuncios por cargar.
     */
    const [hasMore, setHasMore] = useState(true);
    /**
     * Indica la pagina siguiente que se va a solicitar en el request.
     */
    const [after, setAfter] = useState(null);
    const [currentURL, setCurrentURL] = useState("mainAPI");
    /**
     *
     * @type {React.MutableRefObject<null>}
     */
    const elementRef = useRef(null);
    /**
     * Contiene la informacion del card seleccionado.
     */
    const [itemSelected, setItemSelected] = useState({});
    /**
     *  Flag que indica si se muestra, o si esta oculto el dialogo de asignar categoria.
     */
    const [showCategoryDialog, setShowCategoryDialog] = useState(false);
    /**
     *  Contiene el codigo de la categoria selccionado por el usuario.
     */
    const [categorySelected, setCategorySelected] = useState(false);
    /**
     * Contiene el objecto del anuncio que se va a guardar.
     */
    const [ad, setAd] = useState({});

    const createHeaders = (headers = [], setContentType = true) => {
        let headersToRequest = headers;
        if (headers.length === 0) {
            headersToRequest = new Headers();
        }
        if (setContentType) {
            headersToRequest.append("Content-Type", "application/json");
        }
        let auth = getStoredValue(NAME_HEADER_AUTH)
        if (auth) {
            headersToRequest.append("Authorization", `Bearer ${auth}`);
        }
        return headersToRequest;
    }

    /*  END VARS    */


    /*  INIT EVENTS */

    /**
     * Mostrar el dialogo para seleccionar la categoria.
     * @param item
     */
    const launchCategoryDialog = (item) => {
        setShowCategoryDialog(true)
        setAd(item)
    }
    /**
     * Metodo para cerrar el dialogo de categorias.
     */
    const closeCategoryDialog = () => {
        setShowCategoryDialog(false)
    }
    /**
     * Metodo que se ejecuta cuando se selecciona una categoria
     * @param categorySelected
     */
    const onSelectCategory = (categorySelected) => {
        setCategorySelected(categorySelected)
    }
    /**
     * Hacer el submit para guardar el anuncio.
     */
    const submitSaveAd = () => {
        setShowCategoryDialog(false)
        ad.FK_Category_Code = categorySelected;
        saveAd(ad)
    }

    /**
     * (ECA) Función para mostrar la tarjeta de Detalles
     */
    const handleShowDetails = async (item) => {
        setSidebarOpen(false)
        setShowDetails(true);
        setItemSelected(item);
        setItemSelectedDetail(item)
    };

    /**
     * (ECA) Función para cerrar la tarjeta de detalles
     */
    const handleCloseDetails = () => {
        setShowDetails(false);
    };

    /**
     * (ECA)
     */
    const handleCardClick = (item) => {
        if (showDetails && itemSelected.LibraryID === item.LibraryID) {
            handleCloseDetails(); // (ECA) Si la misma tarjeta se clickea, cerrar
        } else {
            handleShowDetails(item); // (ECA) Muestra la tarjeta de detalles
        }
    };
    /*  END EVENTS */


    /*  INIT METHODS    */
    /**
     * Load ad data according to search criteria with improved pagination handling.
     * Attempts to fetch from subsequent pages when an empty result is encountered.
     * @param {number|null} afterValue - Pagination parameter
     * @return {Promise<void>}
     */
/**
     * Load ad data according to search criteria with improved pagination handling.
     * Attempts to fetch from subsequent pages when an empty result is encountered
     * or when the server returns a valid HTTP status with an error message in the body.
     * @param {number|null} afterValue - Pagination parameter (page number).
     * @return {Promise<void>}
     */
    const loadAds = async (afterValue = null) => {
        try {
            let initialPage = afterValue === null || !isNumeric(afterValue) ? 1 : parseInt(afterValue);
            let maxRetries = 3; // Number of additional pages to try if the initial page is empty
            let retryCounter = 0;
            let foundData = false;
            let currentPage = initialPage;
            let totalPages = null; // Initialize total pages as unknown

            while (retryCounter <= maxRetries && !foundData) {
                // If we know the total pages and have exceeded it, stop fetching.
                if (totalPages !== null && currentPage > totalPages) {
                    setHasMore(false);
                    setShowContainerNoMoreData(true);
                    return; // Exit the function completely
                }

                // Adjust the page limit for retry attempts to fetch more data
                const pageLimit = retryCounter > 0 ? 15 : 5;
                const pageParam = `&limit=${pageLimit}&page=${currentPage}`;
                
                // URL for fetching ads
                const url = `https://app.clicspy.com/ads/getads/?${queryString}${pageParam}`;

                console.log(`Attempting to fetch page ${currentPage} with limit ${pageLimit}`);

                const headersToRequest = createHeaders();
                const requestOptions = {
                    method: 'GET',
                    headers: headersToRequest,
                    redirect: 'follow'
                };

                const res = await fetch(url, requestOptions);

                console.log("RES.STATUS", res.status);
                console.log("RES.TYPE", res.type);
                
                if (res.status === 200) {
                    const jsonData = await res.json();

                    console.log(`EL JSON ES ${currentPage}:`, jsonData);

                    // *** REFACTORED LOGIC ***
                    // Handle cases where the server returns 200 OK, but the body indicates an error.
                    if (jsonData.error === true) {
                        console.warn(`Server-side error in 200 OK response on page ${currentPage}: "${jsonData.message}". Skipping page.`);
                        currentPage++;
                        retryCounter = 0; // Reset retry counter as it's a server issue, not empty data.
                        continue; // Proceed to the next iteration of the loop.
                    }

                    // Set total pages from the first valid response
                    if (totalPages === null && jsonData?.info?.totalPages) {
                        totalPages = jsonData.info.totalPages;
                    }

                    if (jsonData?.data?.length > 0 && jsonData.code === 200) {
                        foundData = true;
                        setAfter(currentPage + 1); // Set the next page to fetch

                        setRowsAdsData(prevAds => {
                            const combinedAds = [...prevAds, ...jsonData.data];
                            const uniqueAdsMap = new Map();
                            combinedAds.forEach(ad => {
                                const key = ad.CollationID ? ad.CollationID : ad.LibraryID;
                                if (!uniqueAdsMap.has(key)) {
                                    uniqueAdsMap.set(key, ad);
                                }
                            });
                            return Array.from(uniqueAdsMap.values());
                        });

                        if (currentPage >= totalPages) {
                            setHasMore(false);
                            setShowContainerNoMoreData(true);
                        }
                    } else {
                        // Response is successful but contains no data, try the next page.
                        currentPage++;
                        retryCounter++;
                    }
                } else if (res.status === 500) {
                    // Handle direct 500 server errors
                    console.warn(`Server error (status 500) on page ${currentPage}. Skipping to the next page.`);
                    currentPage++;
                    retryCounter = 0; // Reset retry counter for server errors.
                } else {
                    // Handle other non-200, non-500 responses
                    console.error(`Received status ${res.status}. Stopping further requests.`);
                    retryCounter = maxRetries + 1; // Stop retrying for other critical errors
                }
            }

            if (!foundData) {
                setHasMore(false);
                setShowContainerNoMoreData(true);
            }
        } catch (error) {
            console.error("Error loading ads:", error);
            setHasMore(false);
            setShowContainerNoMoreData(true);
        }
    };    

    function isNumeric(str) {
        // Check if the input is a number and is not NaN
        return !isNaN(str) && !isNaN(parseFloat(str));
    }

    /**
     * Cargar las categorias del usuario.
     * @return {Promise<void>}
     */
    const loadUserCategories = async () => {
        try {
            let results = await fetchCategories();
            setCategories(results)
        } catch (e) {
            console.error(e);
        }
    }

    const fetchAdDetails = async (item) => {
        try {
            // Construct the query parameters
            const params = new URLSearchParams({
                keywords: item.LibraryID,
                ad_reached_countries: 'ALL',
                ad_active_status: 'ALL',
                duplicates: '0',
                limit: '10',
                page: '1',
                isToSaveAds: '1'
            });
    
            //const url = `https://get-ads-anykeyword-240055057184.us-central1.run.app/?${params.toString()}`;
            const url = `https://app.clicspy.com/ads/getads/?${params.toString()}`;
                


            
            const response = await fetch(url);
            const result = await response.json();

            if (!result.data || result.data.length === 0 || result.error || result.code !== 200) {
                throw new Error("No se encontraron detalles para el anuncio");
            }
    
            // Return the first item from the data array since we're only expecting one result
            return result.data[0];
    
        } catch (err) {
            console.error("Error trayendo detalles del anuncio:", err);
            return {};
        }

    };

    /**
     * Guardar el anuncio
     * @param adObject
     * @return {Promise<void>}
     */
    const saveAd = async (adObject) => {
        let adToSave = await fetchAdDetails(adObject)
        if (!adToSave || Object.keys(adToSave).length === 0) {
            adToSave = {...adObject};
        }
        adToSave.LibraryID = adToSave.LibraryID ?? adObject.LibraryID;
        adToSave.Duplicated = adObject.duplicates ?? 0;
        adToSave.FK_Category_Code = adObject.FK_Category_Code ?? categorySelected;
        if (!adToSave.FK_Category_Code) {
            console.error("FK_Category_Code is missing. Cannot save ad.");
            return;
        }

        let request = new RequestSvc()
        let result = await request.post(API.AD, adToSave)
        console.log("RESULTADO DE GUARDADO", result.data)
        setNewRow(result.data.data)
    }

    /**
     * Callback para el IntersectionObserver que maneja la carga infinita
     * Se ejecuta cuando el elemento observado entra en el viewport
     * @param {IntersectionObserverEntry[]} entries - Array de elementos observados
     * @returns {Promise<void>}
     */
    const onIntersection = async (entries) => {
        const firstEntry = entries[0];
        if (firstEntry.isIntersecting && hasMore && queryString !== '') {
            await loadAds(after)
        }
    }
    /**
     * Eliminar las filas que tienen el creativo no existente o invalido.
     * @param arrayAdsObjects
     * @return {Promise<*[]>}
     */
    /*const cleanResponseContent = async (arrayAdsObjects) => {
        let result = {}
        const processedItems = await Promise.all(
            arrayAdsObjects.flatMap(async (adObject) => {
                if (adObject.AdMedia === 'video') {
                    try {
                        let respuesta = await validateExistVideo(adObject.AdCreative)
                        return {
                            ...adObject,
                            existSrc: respuesta.isValid
                        }
                    } catch (error) {
                        return {
                            ...adObject,
                            existSrc: error.isValid
                        }
                    }
                } else {
                    try {
                        let respuesta = await validateExistImg(adObject.AdCreative)
                        return {
                            ...adObject,
                            existSrc: respuesta.isValid
                        }
                    } catch (error) {
                        return {
                            ...adObject,
                            existSrc: error.isValid
                        }
                    }
                }
            })
        )
        return deleteInvalidRows(processedItems);
    }*/

    /**
     * Eliminar del arreglo las filas que tienen la propiedad
     * existSrc=false
     * @param processedItems
     * @return {*[]}
     */
    /*function deleteInvalidRows(processedItems) {
        let cleanData = [];
        processedItems.forEach((item) => {
            if (item.existSrc === true) {
                cleanData.push(item)
            }
        })
        console.log("OJO CON cleanData", cleanData)
        return createDuplicates(cleanData);
    }*/

    /**
     * Crear los duplicados
     * @param cleanData
     * @return {*[]}
     * 9396831630345217
     */
    /*function createDuplicates(cleanData) {
        cleanData.forEach((element) => {
            let indexKey = element.CollationID ?? element.LibraryID;
            if (Object.prototype.hasOwnProperty.call(rowsIndex, indexKey)) {
                rowsIndex[indexKey].duplicated++;
            } else {
                element.duplicated = 1;
                rowsIndex[indexKey] = element;
            }
        })
        // console.log("rowsIndex", rowsIndex)
        let rows = []
        for (let indexKey in rowsIndex) {
            rows.push(rowsIndex[indexKey]);
        }
        console.log("LAS FILAS rows SON = >", rows)
        return rows;
    }*/

    /**
     * Validar si el creativo esta disponible para mostrar cuando es tipo imagen.
     * @param urlImg
     * @return {Promise<unknown>}
     */
   /* async function validateExistImg(urlImg) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve({isValid: true})
            img.onerror = () => reject({isValid: false});
            img.src = urlImg
        })
    }*/

    /**
     * Validar si el creativo esta disponible para mostrar cuando es tipo video.
     * @param urlVideo
     * @return {Promise<unknown>}
     */
    /*function validateExistVideo(urlVideo) {
        return new Promise((resolve, reject) => {
            const video = document.createElement('video')
            video.onloadedmetadata = () => resolve({isValid: true})
            video.onerror = () => reject({isValid: false});
            video.src = urlVideo
        })
    }*/

    /*  END METHODS */
    
    useEffect(() => {
    if (queryString) { // Or however you detect a new search
        setRowsAdsData([]);
        setAfter(null);
        setHasMore(true);
        setShowContainerNoMoreData(false);
        // loadAds(null); // You might need to trigger the first load here if it's not automatic
    }
    }, [queryString]);    

    useEffect(() => {
        loadUserCategories()
    }, []);

    useEffect(() => {
        // Crear un nuevo IntersectionObserver con un margen amplio para precarga
        // y un umbral del 50% de visibilidad del elemento
        const observer = new IntersectionObserver(onIntersection, {rootMargin: '1250px', threshold: 0.5})
        if (observer && elementRef.current) observer.observe(elementRef.current)
        return () => {
            if (observer) observer.disconnect()
        }
    }, [rowsAdsData])


    return (
        <div className={"grid-main-layout"} style={{marginTop: "0", marginRight: "8px"}}>
            <ResponsiveMasonry
                columnsCountBreakPoints={
                    {
                        340: 1, 500: 2, 800: 3, 1200: 4, 1600: 5, 1800: 6, 2200: 7
                    }
                }
                style={{marginLeft: "8px", marginRight: "8px"}}
            >
                <Masonry gutter={"16px"}>
                    {
                        rowsAdsData.map((item, ) => {
                            // let display = item.duplicated >= numberDuplicates ? "grid" : "none";
                            let display = true; //item.duplicates >= numberDuplicates;
                            return display && (
                                <div key={item.LibraryID} style={{display: "grid"}}>
                                    <MemoizedCardAd
                                        item={item}
                                        launchCategoryDialog={launchCategoryDialog}
                                        gridShowAdDetail={handleCardClick}
                                        numberDuplicates={numberDuplicates}
                                    />
                                </div>
                            )
                        })
                    }
                </Masonry>
            </ResponsiveMasonry>
            {
                showCategoryDialog && (
                    <CategoryDialog
                        rows={categories}
                        open={showCategoryDialog}
                        closeCategoryDialog={closeCategoryDialog}
                        onSelectCategory={onSelectCategory}
                        submitSaveAd={submitSaveAd}/>
                )
            }
            {
                hasMore && (
                    <div className="grid-reference-limit-loading" ref={elementRef}>


                        <div style={{
                            marginTop: '20px',
                            display: 'grid',
                            gridTemplateColumns: 'repeat(7, 1fr)',
                            gap: '10px'
                        }}>
                            {[...Array(7)].map((_, index) => (
                                <Skeleton
                                    key={index}
                                    style={{
                                        height: '300px',
                                        borderRadius: '8px',
                                    }}
                                />
                            ))}
                        </div>


                    </div>
                )
            }
        </div>
    )
} // end main function

export default React.memo(AdResultGrid);